import isAuthorDomain from './is-author-domain';

const isProduction = () => {
    const hostname = window.location?.hostname;

    return `${hostname}`.indexOf('eduki.com') >= 0 || isAuthorDomain();
};

export default isProduction;
